
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/experimental-api/pigment-css",
      function () {
        return require("private-next-pages/material-ui/experimental-api/pigment-css.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/experimental-api/pigment-css"])
      });
    }
  